import React from 'react';
import icon from '../../../../assets/dbs/db_springer.png';

const SpringerIcon = () => (
    <div>
        <img style = {{height: 25, paddingBottom:5, paddingRight: 5}} src={icon} alt="springer"/>
    </div>
);
export default SpringerIcon;